<template>
  <Teleport to="body">
    <base-modal
      v-if="isModalVisible"
      class="venue-info-modal"
      :is-visible="true"
      :modal-name="t('reviews-modal-title')"
      @close-modal="isModalVisible = false"
    >
      <div class="venue-info-modal__content">
        <component :is="headingType" class="venue-info-modal__title font-l">
          {{ t('reviews-modal-title') }}
        </component>
        <div class="venue-info-modal__text">
          {{ t('reviews-modal-description') }}
        </div>

        <reviews-block
          v-if="!showVenueInfo"
          :venue-id="locationId"
          :from="dates.dateFrom?.value"
          :to="dates.dateTo?.value"
        />
        <venue-info-block v-else-if="!showReviews" :venue-id="venueId" />

        <base-tab-list v-else :tabs="tabs" full-width>
          <template #venue-info>
            <venue-info-block :venue-id="venueId" />
          </template>
          <template #reviews>
            <reviews-block
              :venue-id="locationId"
              :from="dates.dateFrom?.value"
              :to="dates.dateTo?.value"
            />
          </template>
        </base-tab-list>
      </div>
    </base-modal>
  </Teleport>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseModal from '../2_elements/BaseModal/BaseModal.vue';
import ReviewsBlock from '../2_elements/ReviewsBlock/ReviewsBlock.vue';
import VenueInfoBlock from '../2_elements/VenueInfoBlock/VenueInfoBlock.vue';
import BaseTabList from '../2_elements/BaseTabList/BaseTabList.vue';

const { t } = useI18n();

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  locationId: {
    type: [String, Number],
  },
  venueId: {
    type: [String, Number],
  },
  dates: {
    type: Object,
    default: () => ({}),
  },
  headingType: {
    type: String,
    default: 'h3',
  },
  showVenueInfoFirst: {
    type: Boolean,
    default: false,
  },
});

const isModalVisible = ref(false);

const showVenueInfo = computed(() => props.venueId);
const showReviews = computed(() => props.locationId);

const tabs = computed(() => [
  {
    label: props.showVenueInfoFirst
      ? t('reviews-modal-venue-info-tab')
      : t('reviews-modal-reviews-tab'),
    slotName: props.showVenueInfoFirst ? 'venue-info' : 'reviews',
  },
  {
    label: props.showVenueInfoFirst
      ? t('reviews-modal-reviews-tab')
      : t('reviews-modal-venue-info-tab'),
    slotName: props.showVenueInfoFirst ? 'reviews' : 'venue-info',
  },
]);

const openModal = () => {
  if (!showVenueInfo.value && !showReviews.value) return;
  isModalVisible.value = true;
};

defineExpose({
  openModal,
});
</script>

<style lang="scss">
@import './scss/VenueInfoModal.scss';
</style>
